import { FormikProps } from 'formik'
import { FC } from 'react'
import _ from 'lodash'
import { FarmerLoadWorkTypes } from 'modules/domain/deal/types'
import { t } from 'i18next'
import { RadioItem } from '@agro-club/agroclub-shared'
import { FormRadio } from 'views/components/form/FormRadio'
import { FormCheckboxGroup } from 'views/components/CheckboxGroup/CheckboxGroup'

type Props = {
  formik: FormikProps<any>
  multiple?: boolean
}

export const FarmerWorkTypeSelect: FC<Props> = ({ formik, multiple }) => {
  const fieldName = 'work_type'
  const label = t('deal:accordion.loading.operationType')
  if (multiple) {
    return (
      <FormCheckboxGroup
        keys={Object.keys(FarmerLoadWorkTypes)}
        fieldName={fieldName}
        formik={formik}
        formGroupLabel={label}
        checkboxLabel="deal:accordion.loading"
      />
    )
  }
  return (
    <FormRadio label={label} formik={formik} field={fieldName}>
      <RadioItem value={FarmerLoadWorkTypes.sample} label={t('deal:accordion.loading.sample')} />
      <RadioItem value={FarmerLoadWorkTypes.loading} label={t('deal:accordion.loading.loading')} />
      <RadioItem value={FarmerLoadWorkTypes.documents} label={t('deal:accordion.loading.documents')} />
    </FormRadio>
  )
}
